import {
  StyledEmptyStateContainer,
  StyledGraphEmptyState
} from './GraphEmptyState.style';
import GlassesPeopleImg from './glasses-people.svg';

const DEFAULTS = {
  TITLE: 'Looks like there is nothing to present here',
  DESC: 'Try adjusting your filters'
};

const GraphEmptyState = ({ title = DEFAULTS.TITLE, desc = DEFAULTS.DESC }) => {
  return (
    <StyledEmptyStateContainer>
      <StyledGraphEmptyState data-testid='graph-empty-state'>
        <img src={GlassesPeopleImg} width='75%' />
        <main>
          <div className='primary'>{title}</div>
          <div className='secondary'>{desc}</div>
        </main>
      </StyledGraphEmptyState>
    </StyledEmptyStateContainer>
  );
};

export default GraphEmptyState;
